// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyList_wrapper__12s0C","item":"EmptyList_item__2m1gG"};